module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "features",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r1 row animateblock btt speed-1"
  }, [_c('slick', {
    staticClass: "c1 col-md-12",
    attrs: {
      "id": "features-carousel-1",
      "options": _vm.slickOptions
    }
  }, [_c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon universal"
  }, [_c('span', {
    staticClass: "icon_genius"
  }, [_c('Atom')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Универсально")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Гибкие возможности менять режимы отображения в зависимости от ваших целей. Доски, списки, таблицы, календари, диаграммы. Выбираете в пару кликов любой удобный вид для тех или иных работ.\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon fast"
  }, [_c('span', {
    staticClass: "icon_map_alt"
  }, [_c('Racing')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Быстро")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Ускоряем работу с задачами в разы. Повышаем эффективность управления проектом. Вы тратите минимум времени на ведение проекта и максимум на сам проект.\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon visually"
  }, [_c('span', {
    staticClass: "ion-android-globe"
  }, [_c('ReadingGlasses')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Наглядно")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Всегда видна цельная картина по проекту. Кто чем занят, что сделано, что в работе, что в планах. Наглядные быстрые срезы по статусу любого проекта\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon multitasking"
  }, [_c('span', {
    staticClass: "icon_gift_alt"
  }, [_c('Analytics')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Многозадачность")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Возможность в несколько кликов создать сразу много задач на всю команду, независимо от того в каком виде и откуда вы получили задачи. Действия одновременно с несколькими задачами.\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon notifications"
  }, [_c('span', {
    staticClass: "icon_genius"
  }, [_c('Chat')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Уведомления")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Продуманная политика уведомлений, широкие возможности настроек. Всё что нужно, чтобы уведомления не были назойливыми, а по-настоящему полезными и эффективными\n                        ")])])]), _vm._v(" "), _c('a', {
    staticClass: "features-wrapper",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "features-icon customization"
  }, [_c('span', {
    staticClass: "icon_map_alt"
  }, [_c('Settings')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Настраиваемость")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                            Огромное количество настроек системы под себя. Никто лучше вас не знает специфику вашей работы. Наша политика — не навязывать свои привычки, а сделать инструмент максимально подходящий под ваши процессы.\n                        ")])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Ключевые преимущества")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                Разбираем задачи как "), _c('span', [_vm._v("горячие")]), _vm._v(" пирожки")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a2c5946","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Advantages.vue
// module id = 1228
// module chunks = 1